import { FluentBundle } from 'fluent';
import { GetString } from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import { PolicyRecommendation } from '../../graphQL/types/shared';
import {
  PolicyDimension,
} from '../Utils';
import PolicyCircle from './PolicyCircle';
import PolicyDimensionSelect from './PolicyDimensionSelect';
import PolicyRecommendationBadge from './PolicyRecommendationBadge';

const SectionBase = styled.div`
  grid-row: 2;
`;
const Section = styled(SectionBase)`
  display: grid;
  grid-template-columns: 2rem 1fr;
  grid-template-rows: 1.15rem 1fr;
  padding-left: 12px;

  @media (max-width: 1200px) {
    grid-template-columns: 1.2rem 1fr;
    grid-template-rows: auto 1fr;
    padding-left: 8px;
  }
`;
const PolicyBadgeContainer = styled(Section)`
  border-right: 1px solid #6363634f;

  @media (max-width: 950px) {
    border-right: none;
  }
`;
const PolicyCircleContainer = styled(SectionBase)`
  grid-row: span 3;
  display: flex;
  justify-content: flex-start;
`;

interface Props {
  policyDimension: PolicyDimension;
  setPolicyDimension: (value: PolicyDimension) => void;
  policyRecommendation: PolicyRecommendation;
  getFluentString: GetString;
  fluentBundle: FluentBundle;
  promoteZIndex: () => void;
  restoreZIndex: () => void;
}

const PolicyContainer = (props: Props) => {
  const {
    policyDimension, setPolicyDimension, policyRecommendation,
    getFluentString, fluentBundle, promoteZIndex, restoreZIndex,
  } = props;
  return (
    <>
      <PolicyBadgeContainer style={{gridColumn: 2}}>
        <PolicyRecommendationBadge
          policyRecommendation={policyRecommendation}
          getFluentString={getFluentString}
        />
      </PolicyBadgeContainer>
      <Section
        style={{gridColumn: 3}}
        onMouseEnter={promoteZIndex}
        onMouseLeave={restoreZIndex}
      >
        <PolicyDimensionSelect
          policyDimension={policyDimension}
          setPolicyDimension={setPolicyDimension}
          getFluentString={getFluentString}
          fluentBundle={fluentBundle}
        />
      </Section>
      <PolicyCircleContainer style={{gridColumn: 4}}>
        <PolicyCircle
          policyRecommendation={policyRecommendation}
          policyDimension={policyDimension}
        />
      </PolicyCircleContainer>
    </>
  );
};

export default PolicyContainer;
